module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "button-style": _vm.isEdit ? 'primary' : 'success',
      "heading": _vm.type,
      "size": "default",
      "button-size": "mini",
      "button-text": _vm.isEdit ? '' : _vm.type,
      "buttonIcon": _vm.isEdit ? 'fa fa-edit' : 'fa fa-money-bill',
      "disableButton": !_vm.isManager('finance|management'),
      "circle": _vm.isEdit
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('div', {
    staticClass: "padded"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-alert', {
    attrs: {
      "type": "info1",
      "show-icon": "",
      "title": "Note!",
      "description": 'This will add this item to every invoice ' + (_vm.type === 'Site' ? 'EVERY' : 'THIS') + ' active sharer between start and end dates. After you add this item, can only delete (if system manager finance). Pleae make sure details are correct before you save.',
      "closable": false
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Add " + _vm._s(_vm.type) + _vm._s(_vm.name ? ': ' + _vm.name : ''))]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Type: "), _c('b', [_vm._v(_vm._s(_vm.type))])]), _vm._v(" "), _c('td', [_c('date-input', {
    attrs: {
      "placeholder": "Start",
      "no-form": "",
      "required": ""
    },
    on: {
      "change": _vm.checkRequired
    },
    model: {
      value: (_vm.form.billingStart),
      callback: function($$v) {
        _vm.$set(_vm.form, "billingStart", $$v)
      },
      expression: "form.billingStart"
    }
  })], 1), _vm._v(" "), _c('td', [_c('select-frequency', {
    attrs: {
      "placeholder": "Frequency",
      "label": "",
      "no-form": "",
      "required": ""
    },
    on: {
      "change": _vm.checkRequired
    },
    model: {
      value: (_vm.form.billingPeriod),
      callback: function($$v) {
        _vm.$set(_vm.form, "billingPeriod", $$v)
      },
      expression: "form.billingPeriod"
    }
  })], 1), _vm._v(" "), _c('td', [_c('date-input', {
    attrs: {
      "placeholder": "End",
      "no-form": ""
    },
    model: {
      value: (_vm.form.billingExpiry),
      callback: function($$v) {
        _vm.$set(_vm.form, "billingExpiry", $$v)
      },
      expression: "form.billingExpiry"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qty")]), _vm._v(" "), _c('td', [_vm._v("Ref.")]), _vm._v(" "), _c('td', [_vm._v("Desc.")]), _vm._v(" "), _c('td', [_vm._v("Unit Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s('Tax: ' + (_vm.form.amount ? _vm.taxDue(_vm.amount) : 'N/A')))])]), _vm._v(" "), _c('tr', [_c('td', [_c('number-input', {
    attrs: {
      "placeholder": "Qty.",
      "no-form": ""
    },
    model: {
      value: (_vm.form.quantity),
      callback: function($$v) {
        _vm.$set(_vm.form, "quantity", $$v)
      },
      expression: "form.quantity"
    }
  })], 1), _vm._v(" "), _c('td', [_c('text-input', {
    attrs: {
      "placeholder": "Ref.",
      "no-form": ""
    },
    model: {
      value: (_vm.form.ref),
      callback: function($$v) {
        _vm.$set(_vm.form, "ref", $$v)
      },
      expression: "form.ref"
    }
  })], 1), _vm._v(" "), _c('td', [_c('text-input', {
    attrs: {
      "placeholder": "Description",
      "no-form": "",
      "required": ""
    },
    on: {
      "change": _vm.checkRequired
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('td', [_c('currency-input', {
    attrs: {
      "placeholder": "Unit Amount",
      "label": "",
      "no-form": "",
      "required": ""
    },
    on: {
      "change": _vm.checkRequired
    },
    model: {
      value: (_vm.form.amount),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount", $$v)
      },
      expression: "form.amount"
    }
  })], 1), _vm._v(" "), _c('td', [_c('currency-input', {
    attrs: {
      "label": "",
      "placeholder": "Tax",
      "no-form": ""
    },
    model: {
      value: (_vm.form.tax),
      callback: function($$v) {
        _vm.$set(_vm.form, "tax", $$v)
      },
      expression: "form.tax"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Discount")]), _vm._v(" "), _c('td', [_c('float-input', {
    attrs: {
      "label": "",
      "placeholder": "Discount",
      "prefix": _vm.form.discountPercentage ? _vm.currency : '',
      "suffix": _vm.form.discountPercentage ? '' : '%',
      "no-form": ""
    },
    model: {
      value: (_vm.form.discount),
      callback: function($$v) {
        _vm.$set(_vm.form, "discount", $$v)
      },
      expression: "form.discount"
    }
  })], 1), _vm._v(" "), _c('td', [_c('check-box', {
    attrs: {
      "label": "Disc. Type",
      "no-form": ""
    },
    model: {
      value: (_vm.form.discountPercentage),
      callback: function($$v) {
        _vm.$set(_vm.form, "discountPercentage", $$v)
      },
      expression: "form.discountPercentage"
    }
  }, [_vm._v("\n                    " + _vm._s(!_vm.form.discountPercentage ? '%' : _vm.currency) + "\n                  ")])], 1)]), _vm._v(" "), (_vm.discount) ? _c('tr', [_c('td', [_vm._v("Discount "), _c('b', {
    staticClass: "text-danger pull-right"
  }, [_vm._v(_vm._s(_vm.formatMoney(this.discount)))])])]) : _vm._e(), _vm._v(" "), (_vm.subTotal !== _vm.totals) ? _c('tr', [_c('td', [_vm._v("Sub-Total "), _c('b', {
    staticClass: "text-info pull-right"
  }, [_vm._v(_vm._s(_vm.formatMoney(this.subTotal)))])])]) : _vm._e(), _vm._v(" "), (_vm.form.tax) ? _c('tr', [_c('td', [_vm._v("Tax "), _c('b', {
    staticClass: "text-warning pull-right"
  }, [_vm._v(_vm._s(_vm.formatMoney(this.form.tax)))])])]) : _vm._e(), _vm._v(" "), (_vm.totals) ? _c('tr', [_c('td', [_vm._v("Total "), _c('b', {
    staticClass: "text-primary pull-right"
  }, [_vm._v(_vm._s(_vm.formatMoney(this.totals)))])])]) : _vm._e()])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfbb50f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/SiteInvoiceAction.vue
// module id = 1624
// module chunks = 0